
// This is a helper utility for creating test orders in development
// You can run this in the browser console to create a test order

async function createTestOrder() {
  try {
    console.log('Creating test order...');
    
    // Import supabase client directly if it's not available in global scope
    const supabase = window.supabase || (await import('@/integrations/supabase/client')).supabase;
    
    if (!supabase) {
      console.error('Supabase client not found. Make sure it is properly imported.');
      return { error: 'Supabase client not found', needsAuth: true };
    }

    // Get the user from session storage (our custom auth)
    const sessionUser = sessionStorage.getItem('krix_user');
    if (!sessionUser) {
      console.error('You must be logged in as an admin to create test orders.');
      return { error: 'Not authenticated', needsAuth: true };
    }

    const user = JSON.parse(sessionUser);
    console.log('User from session:', user);

    if (!user.isAdmin) {
      console.error('Only admin users can create test orders.');
      return { error: 'Admin privileges required', needsAuth: true };
    }

    // Check authentication status in Supabase
    const { data: authData, error: authError } = await supabase.auth.getSession();
    
    if (authError) {
      console.error('Error checking Supabase authentication:', authError);
      console.log('Using custom authentication instead.');
    } else {
      console.log('Auth status:', authData?.session ? 'Authenticated with Supabase' : 'Not authenticated with Supabase');
      console.log('Session data:', authData);
    }
    
    // Create unique test order ID
    const orderId = `test_order_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
    console.log('Creating order with ID:', orderId);
    
    // Attempt to insert the order
    const { data, error } = await supabase.from('payment_orders').insert([
      {
        order_id: orderId,
        user_email: user.email,
        amount: 1600,
        status: 'PENDING',
        product_name: 'Starter Plan',
        created_at: new Date().toISOString(),
        payment_method: 'test',
        currency: 'INR',
        user_name: user.name || 'Admin Test User'
      }
    ]).select();
    
    if (error) {
      console.error('Error creating test order:', error);
      if (error.code === '42501' || error.message.includes('row-level security policy')) {
        console.error('Row-level security policy error: You need proper permissions to insert data.');
        console.log('This is likely because:');
        console.log('1. RLS is enabled on the payment_orders table');
        console.log('2. You need to configure Supabase RLS policies to allow admin users to insert data');
        console.log('3. You are logged in with our custom auth system but not with Supabase auth');
        return { error: error.message, needsRlsConfig: true };
      }
      return { error: error.message };
    }
    
    console.log('Test order created successfully!', data);
    console.log('Refresh the page to see the new order.');
    return { success: true, data };
  } catch (err) {
    console.error('Exception creating test order:', err);
    return { error: err.message };
  }
}

// Expose the function globally for console use
if (typeof window !== 'undefined') {
  window.createTestOrder = createTestOrder;
}

// Execute the function directly when called from the admin page
export default createTestOrder;
